import MemberInviteAcceptPane from './MemberInviteAcceptPane';
import './style/member-invite-accept-pane.less';

export default MemberInviteAcceptPane;
